import { render, staticRenderFns } from "./newPeople.vue?vue&type=template&id=21b34e30&scoped=true&"
var script = {}
import style0 from "./newPeople.vue?vue&type=style&index=0&id=21b34e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b34e30",
  null
  
)

export default component.exports